import { Component } from '@angular/core';
import { OpenArhivWindowActionUtil } from '@app/shared/util/open-arhiv-window-util';
import { DynamicFormService } from '@ntap/common';
import {
  ActionWindowParams,
  DEFAULT_ITEM_VIEW,
  EMPTY_ACTION_RESULT,
  ItemActionResult,
  ItemUtil,
  ViewResult,
  ViewResultListener,
  ViewState,
  ViewWindowComponent,
  WindowRegistry
} from '@ntap/core';
import { PrimeNGButtonOpenItemViewActionComponent } from '@ntap/primeng';
import { filter, first, map, Observable, switchMap } from 'rxjs';

@Component({
  selector: 'app-open-povezano-mjesto-action',
  templateUrl: './open-povezano-mjesto-action.component.html',
  styleUrl: './open-povezano-mjesto-action.component.scss',
  providers: [
    {
      provide: ViewResultListener,
      useExisting: ViewWindowComponent
    },
    {
      provide: WindowRegistry,
      useClass: WindowRegistry
    },
    {
      provide: DynamicFormService,
      useClass: DynamicFormService
    }
  ]
})
export class OpenPovezanoMjestoActionComponent extends PrimeNGButtonOpenItemViewActionComponent {
  static MJESTO_VIEW_NAME = 'mjesto_item_readonly';

  protected override doExecuteWithItem(): Observable<ItemActionResult> {
    return this.itemProvider.item$.pipe(
      first(),
      switchMap((item: any) => {
        const mjestoId = item['sv~mjesto~mjesto_id'];
        const itemm: any = {
          $itemType: 'en~mjesto',
          $mainType: 'en~mjesto',
          $parentId: mjestoId,
          $parentType: 'en~mjesto',
          'en~mjesto~id': mjestoId
        };
        const itemProps =
          (mjestoId && {
            $id: mjestoId,
            $type: 'en~mjesto',
            $itemType: 'en~mjesto'
          }) ||
          {};
        const keyItem = ItemUtil.extractItemKey(itemm);
        const viewState = Object.assign({}, keyItem, itemProps);
        return this.doOpenWindow(viewState).pipe(
          filter((viewResult: any) => this.acceptResult(viewResult)),
          map(
            (viewResult) =>
              new ItemActionResult(EMPTY_ACTION_RESULT, viewResult.viewData[0])
          )
        );
      })
    );
  }
  private doOpenWindow(viewState: ViewState): Observable<ViewResult> {
    return OpenArhivWindowActionUtil.open(
      this.getActionWindowParams(),
      viewState
    );
  }
  protected override getActionWindowParams(): ActionWindowParams {
    this.doSetDefaultActionViewName();
    const actionWindowParams = OpenArhivWindowActionUtil.createParams(
      this.action,
      this.windowRegistry,
      OpenPovezanoMjestoActionComponent.MJESTO_VIEW_NAME
    );
    return actionWindowParams;
  }
  private doSetDefaultActionViewName() {
    if (!this.action.$openViewName) {
      this.action.$openViewName = DEFAULT_ITEM_VIEW;
    }
  }
}
